import { ArrowRight } from 'lucide-react';

import { shorten } from '@/lib/format';

export function RoutePills({ nodes }: { nodes: string[] }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {nodes.map((node, index) => (
        <div key={`${node}-${index}`} className="flex items-center gap-2">
          <span className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-700 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-200">
            {shorten(node, 42)}
          </span>
          {index < nodes.length - 1 ? <ArrowRight className="h-4 w-4 text-slate-400" /> : null}
        </div>
      ))}
    </div>
  );
}
